<script>
import axios from "axios";
import useSharedData from "@/use/SharedData";
import useValidation from "@/use/Validation";
import useTools from "@/use/Tools";
import useSharedMethod from "@/use/SharedMethod";
import {useOrganizationalChartStore} from "@/stores/OrganizationalChart";
import {computed, onMounted, ref} from "vue";

export default {
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        deleteAction: Boolean,
    },
    setup(props) {

        const readOnly = computed(() => props.deleteAction);

        const {mxRules} = useValidation();
        const {$route, $refs} = useTools();
        const {getBack} = useSharedMethod();
        const {dialog, loading, overlay} = useSharedData();

        const organizationalChartStore = useOrganizationalChartStore();
        const organizationalChart = ref({
            teteId: $route.params.parentId,
            head: false
        });

        function findById(id) {
            loading.value = true;
            axios.get(`/organizationalCharts/${id}`).then((response) => {
                organizationalChart.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function save() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.post('/organizationalCharts', organizationalChart.value).then((response) => {
                    organizationalChartStore.addNode(response.data)
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        function update() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.put('/organizationalCharts', organizationalChart.value).then((response) => {
                    organizationalChartStore.updateNode(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        function remove() {
            loading.value = true;
            axios.delete(`/organizationalCharts/${organizationalChart.value.id}`).then(() => {
                organizationalChartStore.removeNode(organizationalChart.value.id)
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => {
            if (!props.addAction)
                findById($route.params.id);
        });

        return {
            readOnly,
            mxRules,
            organizationalChartStore,
            dialog,
            loading,
            overlay,
            organizationalChart,
            getBack,
            save,
            update,
            remove,
        }
    }
};
</script>

<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="450"
    >
        <v-card flat>
            <w-dialog-toolbar
                :add-action="addAction"
                :update-action="updateAction"
                :delete-action="deleteAction"
            />
            <w-overlay
                :overlay="overlay"
                :loading="loading"
                :delete-action="deleteAction"
                @remove="remove"
                @cancel="overlay = false"
            />
            <v-card-text>
                <v-container fluid>
                    <v-form ref="form" lazy-validation>
                        <v-row>
                            <v-col cols="12">
                                <w-label :label="$t('common.name')" required/>
                                <w-text-field
                                    v-model="organizationalChart.name"
                                    :readonly="readOnly"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-label :label="$t('worker.responsible')" required/>
                                <str-worker-autocomplete
                                    v-model="organizationalChart.workerId"
                                    :readonly="readOnly"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-add
                    :show="addAction"
                    :loading="loading"
                    @press="save"
                />
                <w-btn-update
                    :show="updateAction"
                    :loading="loading"
                    @press="update"
                />
                <w-btn-delete
                    :show="deleteAction"
                    :loading="loading"
                    @press="overlay = true"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
